import _ from 'lodash'
import HelperPlatform from 'utils/helper-platform'
import { StyleSheet, useWindowDimensions } from 'react-native'
import i18n from 'utils/i18n'
import ThemedBlock from 'components/atoms/ThemedBlock'
import HelperString from 'utils/helper-string'
import ThemedSectionList from 'components/atoms/ThemedSectionList'
import ThemedBlockTitle from 'components/atoms/ThemedBlockTitle'
import BookingsListItem from 'scenes/management/bookings/_components/BookingsListItem'
import React, { useMemo } from 'react'
import { ThemedValues } from 'styles/themed'

const BookingsGroup = ({ item, inList = false, searchValue, reload }) => {
	
	const dimensions = useWindowDimensions()
	
	const bookings = useMemo( () => {
		let bookings = _.clone( item.bookings );
		
		// When there is a search -> filter!
		if( searchValue !== null && !_.isEmpty( searchValue ) ) {
			bookings = _.filter( bookings, booking => {
				let containsName = false;
				
				_.forEach( booking.data, employee => {
					if( containsName !== true && _.includes( _.get( employee, 'name', '' ).toLowerCase(),  searchValue ) ) {
						containsName = true;
						return true;
					}
				})
				
				return containsName;
			})
		}
		
		return _.map( bookings, booking => {
			booking.uniqueKey = HelperString.random( 7 )
			if( booking.booking_invitation !== null ) {
				booking.subtitle = i18n.t('management:generic.invited_by', {
					name: _.get( booking.booking_invitation, ['employee', 'name'], '' )
				})
			}
			
			return booking
		})
	}, [ item.bookings, searchValue ])


	// Create the styles based on if it is in the list or not
	const groupStyle = {
		marginRight: ThemedValues.stackSpace,
		...HelperPlatform.select({
			native: {
				width: dimensions.width * 0.8,
			},
			web: {
				width: inList ? '500px' : null,
				maxWidth: '100%'
			}
		})
	}
	
	return (
		<ThemedBlock
			key={ HelperString.hash( 'render-group', item ) }
			style={ groupStyle }
			transparent>
			
			<ThemedSectionList
				header={ item.title === null ? null : (
					<ThemedBlockTitle
						style={ styles.groupHeaderTitle }
						smallPadding>
						
						{ item.title }
					</ThemedBlockTitle>
				)}
				sections={ bookings }
				renderItem={ props => {
					return (
						<BookingsListItem
							{ ...props }
							reload={ reload }
						/>
					);
				} }
			/>
		</ThemedBlock>
	)
}

const styles = StyleSheet.create({
	groupHeaderTitle: {
		marginBottom: 0
	},
});

export default BookingsGroup
